import { backAttribute, frontAttribute, TireSide } from '..';
import useProductFilterCount from '../../../queries/useProductFilterCount';
import type { AttributeMatcherAndExpression } from '../../../types';
import { useProductListOptionsContext } from '../../ProductList/context/ProductListOptionsContext';

const getSideFilterParams = (
    filterField: string,
    attributeFilters: AttributeMatcherAndExpression,
    skip: boolean
) => {
    return {
        filterField,
        additionalFilters: {
            attributeFilters: {
                ...attributeFilters,
                children: attributeFilters.children.filter(
                    filter =>
                        (filter as { name: string }).name !== filterField &&
                        (filter as { name: string }).name !==
                            'PIM_ATT_MATCHCODE'
                ),
            },
        },
        skip,
    };
};

const useTireSideFilterValues = ({
    side,
    skip,
}: {
    side: TireSide;
    skip: boolean;
}) => {
    const {
        filters: { backAttributes, frontAttributes },
    } = useProductListOptionsContext();

    const sideAttributes =
        side === TireSide.front ? frontAttributes : backAttributes;
    const sideAttribute =
        side === TireSide.front ? frontAttribute : backAttribute;

    const attributeFilters: AttributeMatcherAndExpression = {
        type: 'and',
        children: [sideAttribute, ...sideAttributes],
    };

    const { productFilterValues: PIM_ATT_MATCHCODE } = useProductFilterCount({
        filterField: 'PIM_ATT_MATCHCODE',
        filterExceptions: [
            'PIM_ATT_TIRE_WIDTH_MOTO',
            'PIM_ATT_TIRE_HIGHT_MOTO',
            'PIM_ATT_DIAMETER',
        ],
        additionalFilters: {
            attributeFilters: sideAttribute,
        },
        skip,
    });

    const { productFilterValues: PIM_ATT_TIRE_WIDTH_MOTO } =
        useProductFilterCount(
            getSideFilterParams(
                'PIM_ATT_TIRE_WIDTH_MOTO',
                attributeFilters,
                skip
            )
        );
    const { productFilterValues: PIM_ATT_TIRE_HIGHT_MOTO } =
        useProductFilterCount(
            getSideFilterParams(
                'PIM_ATT_TIRE_HIGHT_MOTO',
                attributeFilters,
                skip
            )
        );
    const { productFilterValues: PIM_ATT_DIAMETER } = useProductFilterCount(
        getSideFilterParams('PIM_ATT_DIAMETER', attributeFilters, skip)
    );

    return {
        PIM_ATT_MATCHCODE,
        PIM_ATT_TIRE_WIDTH_MOTO,
        PIM_ATT_TIRE_HIGHT_MOTO,
        PIM_ATT_DIAMETER,
    };
};

export const useTireFilterValues = ({ skip }: { skip: boolean }) => {
    const { productFilterValues: PIM_ATT_MATCHCODE } = useProductFilterCount({
        filterField: 'PIM_ATT_MATCHCODE',
        filterExceptions: [
            'PIM_ATT_TIRE_WIDTH_MOTO',
            'PIM_ATT_TIRE_HIGHT_MOTO',
            'PIM_ATT_DIAMETER',
        ],
        skip,
    });

    const { productFilterValues: PIM_ATT_TIRE_WIDTH_MOTO } =
        useProductFilterCount({
            filterField: 'PIM_ATT_TIRE_WIDTH_MOTO',
            skip,
        });
    const { productFilterValues: PIM_ATT_TIRE_HIGHT_MOTO } =
        useProductFilterCount({ filterField: 'PIM_ATT_TIRE_HIGHT_MOTO', skip });
    const { productFilterValues: PIM_ATT_DIAMETER } = useProductFilterCount({
        filterField: 'PIM_ATT_DIAMETER',
        skip,
    });

    return {
        PIM_ATT_MATCHCODE,
        PIM_ATT_TIRE_WIDTH_MOTO,
        PIM_ATT_TIRE_HIGHT_MOTO,
        PIM_ATT_DIAMETER,
    };
};

export default useTireSideFilterValues;
